import type { SuggestedAddress } from '../../../core/models/address-validate';

/**
 * Returns true when AVS returned a suggested address the user can accept.
 */
export function hasActionableSuggestedAddress(
  suggestedAddress: SuggestedAddress | null | undefined,
): boolean {
  if (!suggestedAddress) {
    return false;
  }

  return [
    suggestedAddress.addressLine1,
    suggestedAddress.municipalityName,
    suggestedAddress.postalCode,
  ].some((value) => value.trim().length > 0);
}
